import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import Panel from '../../../../../../components/angle/Panel';
import { formInputValidation } from '../../../../../../services/helper/form-helper';
import AddClientForm from '../../components/ClientForm';
import {
    addNewClient,
    updateAddNewClientPayload
} from '../../../../../../services/redux/employee/clientInformation/actions';
import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';
class AddNewClient extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.onSaveClick = this.onSaveClick.bind(this);
    }
    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }
    onSaveClick() {
        let { clientInformation, history, addNewClient } = this.props;
        let payload = clientInformation.addNewClientData;
        if (formInputValidation(this.formRef.current)) {
            addNewClient(payload).then(response => {
                if (response.status === 200) {
                    history.push('/client-information');
                }
            });
        }
    }

    render() {
        let {
            clientInformation,
            commonData,
            updateAddNewClientPayload
        } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        return (
            <div>
                <Panel
                    showHeader
                    header="Add Client"
                    showFooter
                    footerComponents={saveButton}
                >
                    <div>
                        <AddClientForm
                            clientData={clientInformation.addNewClientData}
                            updateClientData={updateAddNewClientPayload}
                            countryList={commonData.countries}
                            stateList={commonData.states}
                            formRef={this.formRef}
                        />
                    </div>
                </Panel>
                {clientInformation.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            addNewClient,
            updateAddNewClientPayload
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddNewClient));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/AddClient/index.js